<template>
  <div class="orders-table mini-orders-table">
    <DataTable
      name="orders"
      :items="get_data.orders"
      :tablehdrs="tablehdrs"
      :itemsperpage="5"
      :paginationOptions="[ 5 ]"
      hidefooter
    >
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="$router.push({ name: 'orders:view', params: { id: item.id }})"
          :class="getClasses(item)"
          class="mobile_row table-row mini-order-row"
        >
          <td class="id-col">
            <v-tooltip right v-if="!item.read">
              <template v-slot:activator="{ on }">
                <v-btn icon small v-on="on" class="order-alert">
                  <v-icon small color="red">mdi-exclamation-thick</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.view.unread }}</span>
            </v-tooltip>
            <strong># {{ item.id }}</strong>
          </td>
          <td class="datetime-col">
            {{ formatDate(item.datetime) }}
          </td>
          <td class="customer-col">
            <CustomerCard
              v-model="item.customer"
              :noneRef="item.ref"
              hideId
              hideCpf
              mini
            />
          </td>
          <td v-if="permissions.orders.viewprices" class="total-col">
            <p class="ma-0">{{ formatCurrency(item.total) }}</p>
          </td>
          <td class="status-col">
            <span
              class="status"
              :class="`${getStatus(item.status).color}--text`"
            >
              <v-icon
                v-text="getStatus(item.status).icon"
                :color="getStatus(item.status).color"
                class="mr-1"
                small
              />
              {{ getStatus(item.status).title }}
            </span><br />
            <span
              class="status"
              :class="`${getPaid(item).color}--text`"
            >
              <v-icon
                v-text="getPaid(item).icon"
                :color="getPaid(item).color"
                class="mr-1"
                small
              />
              {{ getPaid(item).title }}
            </span>
          </td>
          <td class="actions-col">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  small
                  @click.stop="$router.push({ name: 'orders:view', params: { id: item.id }})"
                >
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>{{ lang.orders.actions.view }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import CustomerCard from '@/components/customers/templates/OrderCard'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import orders from '@/components/orders/mixins/index'

export default {
  components: { DataTable, CustomerCard },
  mixins: [ appdata, utils, orders ],
  computed: {
    tablehdrs: {
      get: function () {
        const ordersdtbhdr = this.tableheaders.home.recent_orders
        if (!this.permissions.orders.viewprices) {
          const totalheader = ordersdtbhdr.find(element => element.value === 'total')
          if (totalheader) {
            const index = ordersdtbhdr.indexOf(totalheader)
            ordersdtbhdr.splice(index, 1)
          }
        }
        return ordersdtbhdr
      }
    }
  }
}
</script>

<style src="@/components/orders/styles/list.scss" lang="scss"></style>
<style lang="scss">
.mini-orders-table {
  #app & {
    .v-data-table__wrapper {
      border-radius: 7px;
      overflow: hidden;
      .v-data-table-header {
        background: #fcfcfc !important;
      }
    }
  }
}

.orders-table .mini-order-row {
  #app & {
    cursor: pointer;
    &:hover {
      filter: brightness(110%) !important;
    }
    &.read {
      opacity: 0.74 !important;
    }
    .actions-col {
      min-width: 0px !important;
    }
  }
}
</style>